

















































































import * as R from 'ramda';
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { _Boolean } from '@/API';
import { isTenantUsingMoveFileTask } from '@/appsync/service/TenantUsingMoveFileTaskQueryService'; // TODO: Delete this when movefile Task is no longer needed(ref:#2465, #2494)
import TaskListItemDetail from '@/components/organisms/TaskListItemDetail.vue';
import { commonModule } from '@/store/modules/CommonStore'; // TODO: Delete this when movefile Task is no longer needed(ref:#2465, #2494)
import {
  TaskItemForDB,
  TaskMetadataItemForFront,
  TaskMetadataArgItemForFront,
} from '@/types/type';
import {
  _BooleanEnum2boolean,
  boolean2_BooleanEnum,
} from '@/utils/CommonUtils';
import { returnEmptyArrayIfNilInputOrElseProcess } from '@/utils/EventCalendarUtils';
import {
  getEmptyArgs,
  mergeArgsOfTaskMetadataAndTask,
  toTaskMetadataItem,
} from '@/utils/TaskUtils';

@Component({
  components: {
    TaskListItemDetail,
  },
})
export default class TaskListItem extends Vue {
  private selectedBatchItem = { batch: '', batchName: '' };

  @Prop()
  private duplicateOutputPathExist!: boolean;

  @Prop()
  private task!: TaskItemForDB;

  @Prop()
  private index!: number;

  @Prop()
  private allTaskMetadatas!: TaskMetadataItemForFront[];

  @Prop({ required: true })
  private readonly draggingItemIndex!: number | null;

  private taskTitle!: string;

  private includeInDownload!: boolean;

  // TODO: Delete this when movefile Task is no longer needed(ref:#2465, #2494)
  private isTenantIncludedInTenantUsingMoveFileTask: boolean = false;
  //

  private getBatchAndBatchName = R.pickAll(['batch', 'batchName']);

  public async created(): Promise<void> {
    this.selectedBatchItem = this.getBatchAndBatchName(this.task);
    this.includeInDownload = this.task.includeInDownload
      ? _BooleanEnum2boolean(this.task.includeInDownload)
      : true;
    this.taskTitle = this.task.title;
    this.isTenantIncludedInTenantUsingMoveFileTask = await isTenantUsingMoveFileTask(
      commonModule.loginInfo.tenant
    );
  }

  public async beforeUpdate(): Promise<void> {
    this.taskTitle = this.task.title;
    this.includeInDownload = this.task.includeInDownload
      ? _BooleanEnum2boolean(this.task.includeInDownload)
      : true;
  }

  private get getTaskBatchNames(): string[] {
    const getBatchNames = R.map(this.getBatchAndBatchName);

    // TODO: Delete this when movefile Task is no longer needed(ref:#2465, #2494)
    if (!this.isTenantIncludedInTenantUsingMoveFileTask) {
      const filteredTaskMetadatas = R.reject(R.propEq('batch', 'movefile'))(
        this.allTaskMetadatas
      );
      return returnEmptyArrayIfNilInputOrElseProcess(getBatchNames)(
        filteredTaskMetadatas
      );
    }
    //

    return returnEmptyArrayIfNilInputOrElseProcess(getBatchNames)(
      this.allTaskMetadatas
    );
  }

  private get getTaskTitle(): string {
    return R.prop('title')(this.task);
  }

  private get getTextFields() {
    this.selectedBatchItem = this.getBatchAndBatchName(this.task);

    if (!this.selectedBatchItem || !this.selectedBatchItem.batch) {
      return [];
    }
    const selectedTaskMetadata = this.getSelectedTaskMetadata();

    const mergedArgs = mergeArgsOfTaskMetadataAndTask(
      selectedTaskMetadata,
      this.task
    ) as TaskMetadataArgItemForFront[];

    const argsWithValue = mergedArgs.map(arg => ({
      ...arg,
      replaceInFileName: arg.replaceInFileName
        ? _BooleanEnum2boolean(arg.replaceInFileName as any)
        : false,
    }));

    return argsWithValue;
  }

  // TODO: Add logic when we start supporting dropdown fields
  private get getDropDownFields() {
    return [];
  }

  private get isTaskSelected(): boolean {
    return Boolean(this.selectedBatchItem.batch);
  }

  private changeTaskBatchName() {
    if (!this.selectedBatchItem || !this.selectedBatchItem.batch) {
      this.makeTaskEmpty();
      return;
    }

    const selectedTaskMetadata = this.getSelectedTaskMetadata();

    if (this.task.batchName === this.task.title && selectedTaskMetadata) {
      this.task.title = selectedTaskMetadata.batchName;
    }
    this.task.batchName = this.selectedBatchItem.batchName;
    if (selectedTaskMetadata) {
      this.task.product = selectedTaskMetadata.product;
      this.task.batch = selectedTaskMetadata.batch;
      this.task.version = selectedTaskMetadata.version;
      this.task.title = R.defaultTo(
        selectedTaskMetadata.batchName,
        this.task.title
      );
      this.task.versionProductBatch = selectedTaskMetadata.versionProductBatch;
      this.task.taskMetadata = toTaskMetadataItem(selectedTaskMetadata);
      this.task.args = getEmptyArgs(selectedTaskMetadata);
    }
  }

  private getSelectedTaskMetadata() {
    return R.find(
      R.propEq('batch', this.selectedBatchItem.batch),
      this.allTaskMetadatas
    );
  }

  @Emit('updateTaskListItem')
  private updateTaskListItem(data: {
    textFields: TaskMetadataArgItemForFront[];
  }) {
    this.task.args = data.textFields.map(field => ({
      option: field.option,
      order: field.order,
      value: field.value,
      replaceInFileName: boolean2_BooleanEnum(field.replaceInFileName ?? false),
    }));
  }

  private updateIncludeInDownload(value: boolean) {
    this.task.includeInDownload = boolean2_BooleanEnum(value);
  }

  private updateReplaceInFileName(order: number, value: boolean) {
    const arg = this.task.args.find(a => a.order === order);
    if (arg) {
      arg.replaceInFileName = boolean2_BooleanEnum(value);
    }
  }

  private updateTaskTitle(title: string) {
    this.task.title = title ? title : this.task.batchName;
  }

  private makeTaskEmpty() {
    this.task.batchName = '';
    this.task.product = '';
    this.task.batch = '';
    this.task.version = '';
    this.task.title = '';
    this.task.versionProductBatch = '';
    this.task.taskMetadata = null;
    this.task.args = [];
    this.task.includeInDownload = _Boolean._true;
  }
}
